import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * NavLink Atom Component
 * Basic navigation link element using React Router
 */
const NavLink = ({ 
  to, 
  href,
  children, 
  active = false,
  className = '',
  onClick,
  ...props 
}) => {
  const location = useLocation();
  const linkTo = to || href || '#';
  
  // Determine if link is active based on current location
  const isActive = active || location.pathname === linkTo;
  
  const baseClasses = 'px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200';
  const activeClasses = isActive
    ? 'bg-blue-100 text-blue-700' 
    : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900';
  
  const combinedClasses = `${baseClasses} ${activeClasses} ${className}`;

  const handleClick = (e) => {
    if (onClick) {
      onClick({ to: linkTo, label: children });
    }
  };

  return (
    <Link 
      to={linkTo}
      className={combinedClasses}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Link>
  );
};

export default NavLink;

